import Dialog from "@material-ui/core/Dialog";
import React from "react";
import AlertFeedback from "../modals/AlertFeedback";
import { ModalTypes, useMonitorResidentsCallbacks } from "./Callbacks";

import { useSwipeable } from "react-swipeable";
import { ResidentActivityType } from "../../redux/residentActivityPlan";
import ActivityFeedback from "../modals/ActivityFeedback";
import FullResidentCard from "../modals/FullResidentCard";
import VitalSign from "../modals/VitalSign";
import MonitorContent from "./MonitorContent";
import "./styles.scss";
import DevicesStatuses from "../modals/DevicesStatuses";
import ResidentStatuses from "../modals/ResidentStatuses";
import UserNearbyRoomStatus from "../modals/UserNearbyRoomStatus";

export const ShowActions = (
  eventType: ModalTypes,
  callback: (...args: any) => void,
  canGoBack: boolean,
  args: any
): JSX.Element => {
  switch (eventType) {
    case ModalTypes.SHOW_USER_NEAR_ROOM_STATUSES:
      return <UserNearbyRoomStatus callback={callback} residentId={args[0]} />;
    case ModalTypes.SHOW_RESIDENT_STATUSES:
      return <ResidentStatuses callback={callback} residentId={args[0]} />;
    case ModalTypes.SHOW_DEVICES_STATUSES:
      return <DevicesStatuses callback={callback} residentId={args[0]} />;
    case ModalTypes.SHOW_FULL_RESIDENT_CARD:
      return <FullResidentCard callback={callback} residentId={args[0]} />;
    case ModalTypes.SHOW_ALERT_FEEDBACK:
      const alert = args;
      return <AlertFeedback alert={alert} callback={callback} />;
    case ModalTypes.SHOW_ACTIVITY_FEEDBACK: {
      const reminder = args[0];
      const residentId = args[1];
      if (reminder.activityType === ResidentActivityType.VITAL_SIGNS)
        return (
          <VitalSign
            reminder={reminder}
            residentId={residentId}
            callback={callback}
          />
        );
      return (
        <ActivityFeedback
          reminder={reminder}
          residentId={residentId}
          callback={callback}
        />
      );
    }
  }

  return null;
};
const Monitor = (): JSX.Element => {
  const { callback, modalComponent, onClose } = useMonitorResidentsCallbacks();

  console.log("monitorStatus");
  const handlers = useSwipeable({
    onSwipedRight: () => callback(ModalTypes.BACK),
  });
  return (
    <>
      <MonitorContent callback={callback} />

      <Dialog
        fullScreen={true}
        open={modalComponent != null}
        onClose={onClose}
        aria-labelledby="customized-dialog-title"
      >
        <div className="swipable-popups" {...handlers}>
          {modalComponent}
        </div>
      </Dialog>
    </>
  );
};

export default React.memo(Monitor);
